"use client";

import React, { useRef } from "react";
import { Card, CardContent } from "../ui/card";
import { CheckCircle, Target, Users } from "lucide-react";
import SectionHeader from "../common/section-header";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

const values = [
  {
    title: "Quality Excellence",
    description:
      "We maintain the highest standards in every project, ensuring precision and compliance with all regulations.",
    icon: CheckCircle,
  },
  {
    title: "Client Partnership",
    description:
      "We build lasting relationships with our clients, working as trusted partners throughout every project phase.",
    icon: Users,
  },
  {
    title: "Innovation Focus",
    description:
      "We embrace cutting-edge technology and innovative approaches to deliver superior engineering solutions.",
    icon: Target,
  },
];

function ValuesSection() {
  const valuesRef = useRef(null);
  useGSAP(
    () => {
      const cards = gsap.utils.toArray(".values-card");
      gsap.registerPlugin(ScrollTrigger);
      gsap.fromTo(
        cards,
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".values-card",
            start: "top 80%",
            toggleActions: "play none none reset",
          },
        },
      );
    },
    { scope: valuesRef },
  );

  return (
    <section ref={valuesRef} className="bg-white py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          title="What Defines Us"
          highlightedTitle="Our Core Values,"
          bodyText="At Rake Engineering Consultancy, our values are the foundation of our success. They guide our actions, shape our culture, and define our commitment to excellence in engineering and consultancy services."
        />

        <div className="mt-10 grid gap-8 md:grid-cols-3">
          {values.map((value) => (
            <Card
              key={value.title}
              className="values-card rounded-none border-gray-200 bg-gray-50 text-center"
            >
              <CardContent className="p-8">
                <value.icon className="mx-auto mb-4 h-12 w-12 text-orange-600" />
                <h3 className="mb-3 text-xl font-bold text-gray-900">
                  {value.title}
                </h3>
                <p className="text-gray-600">{value.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ValuesSection;
